export function getAuthRedirectUrl(path = "/#/login") {
  if (typeof window === "undefined") {
    return path;
  }

  return new URL(path, window.location.origin).toString();
}
